/**
 * Store: Multi-store
 * -----------------------------------------------------------------------------
 * Handles localisation events and data.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    current: {
      country: {},
      langauge: {},
    },
    geolocation: {
      countryCode: '',
      name: '',
    },
    preference: false,
    selectedStore: {},
    suggestedStore: {
      country: {},
      language: {},
    },
    supported: {},
  }),

  mutations: {

    /**
     * Set current country and language.
     * @param {Object} current - Current Shopify localization country and
     * language.
     */
    SET_CURRENT(state, current) {
      state.current = current
    },

    /**
     * Set geolocation.
     * @param {Object} geolocation - Formatted geolocation.
     * @param {String} geolocation.country - Country ISO code.
     * @param {String} geolocation.name - Country name.
     */
    SET_GEOLOCATION(state, geolocation) {
      state.geolocation = geolocation
    },

    /**
     * Set language.
     * @param {Object} language - Shopify localization.language.
     */
    SET_LANGUAGE(state, language) {
      state.language = language
    },

    /**
     * Set preference.
     * @param {Object} preference - User preference.
     * @param {String} preference.country - Country ISO code.
     * @param {String} preference.name - Country name.
     */
    SET_PREFERENCE(state, preference) {
      state.preference = preference
    },

    /**
     * Set selected store.
     * @param {String} selected - Selected store.
     */
    SET_SELECTED_STORE(state, selected) {
      state.selectedStore = selected
    },

    /**
     * Set suggested store.
     * @param {Object} suggestedStore - Suggested store.
     * @param {String} suggestedStore.country - Suggested country object.
     * @param {String} suggestedStore.language - Suggested language object.
     */
    SET_SUGGESTED_STORE(state, suggestedStore) {
      state.suggestedStore = suggestedStore
    },

    /**
     * Set supported.
     * @param {Object} supported - Supported countries.
     */
    SET_SUPPORTED(state, supported) {
      state.supported = supported
    },
  },

  actions: {

    /**
     * Commit current country and language.
     * @param {Object} current - Current Shopify localization country and
     * language.
     */
    setCurrent({ commit }, current) {
      commit('SET_CURRENT', current)
    },

    /**
     * Commit geolocation.
     * @param {Object} response - Response from Shopify geolocation app.
     */
    setGeolocation({ commit }, response) {
      const { name, handle: country } = response.detected_values.country
      commit('SET_GEOLOCATION', { country, name })
    },

    /**
     * Commit preference.
     * @param {Object} preference - User preference.
     */
    setPreference({ commit }, preference) {
      commit('SET_PREFERENCE', preference)
    },

    /**
     * Commit selected store.
     * @param {String} selected - Selected store.
     */
    setSelectedStore({ commit }, selected) {
      commit('SET_SELECTED_STORE', selected)
    },

    /**
     * Commit suggested store.
     * @param {Object} suggestedStore - Suggested store.
     */
    setSuggestedStore({ commit }, suggestedStore) {
      commit('SET_SUGGESTED_STORE', suggestedStore)
    },

    /**
     * Commit supported.
     * @param {Object} supported - Supported countries.
     */
    setSupported({ commit }, supported) {
      commit('SET_SUPPORTED', supported)
    },
  },
}
